var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThickCrossHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.928,
    height: 8.928,
    viewBox: "0 0 8.928 8.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-delete",
    d: "M5,5l6.807,6.807m0-6.807L5,11.807",
    transform: "translate(-3.939 -3.939)",
    fill: "#212529",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThickCrossHover);
export default __webpack_public_path__ + "static/media/thick-cross-hover.39ed8c940b1de9b6ed9b35bf678f994a.svg";
export { ForwardRef as ReactComponent };